import { standardDate } from '@/helpers/DateFormatter';
export class SurveyRespondentCompletedTaskModel {
    constructor(payload) {
        this.createdAt = payload.createdAt;
        this.name = payload.task.name;
        this.points = payload.task.points;
    }
    get dateOfCompletion() {
        return standardDate(this.createdAt);
    }
}
